import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";

import { GET_SITE_DOCUMENTS, UPLOAD_SITE_DOCUMENT, PREVIEW_SITE_DOCUMENT, DOWNLOAD_SITE_DOCUMENT, DOWNLOAD_SITE_DOCUMENTS} from "./actions.type";
import {forceDownload, filePreview} from "@/common/documentFunctions"
import {formatDate} from "../common/formatting";
import constants from "../common/constants";

const SiteDocumentModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    siteDocuments: {},
    siteDocumentsUrl: "/sitedocuments"
  },
  mutations:{
    storeSiteDocuments (state, documentData) {
      state.siteDocuments.received = documentData.received;
      state.siteDocuments.submitted = documentData.submitted;
    },
    formatSiteDocuments(state) {
      var docUrl = this.getters.getSiteDocumentsUrl + '/';
      var frmtDocs = [];
      //Only two loops received/submitted
      Object.keys(state.siteDocuments).forEach( function (docType, key) {
        //docType = received/submitted
        frmtDocs[docType] = [];
        //Loop through each document for given type.
        state.siteDocuments[docType].forEach(function(doc, i) {
          let newDoc = {
            data: {
              id: doc.id
            },
            actions: [
              {
                link: docUrl + doc.id,
                icon: 'show'
              },
              {
                link: docUrl + doc.id,
                icon: 'download'
              }
            ],
            dateUploaded: {
              value: formatDate(doc.created_at),
              realValue: doc.created_at
            },
            desc: {
              value: doc.description
            },
            docName: {
              value: doc.name
            },
          };
          frmtDocs[docType].push(newDoc);
          if (doc.hasOwnProperty('user')) {
            newDoc.uploadedBy = {value: constants.updateUploadedBy(doc.description, `${doc.user.first_name} ${doc.user.last_name}`)};
          }
        });
      });
      state.siteDocuments.received = frmtDocs['received'];
      state.siteDocuments.submitted = frmtDocs['submitted'];
    }
  },
  getters: {
    getSiteDocumentsUrl: state => {
      return state.siteDocumentsUrl;
    },
    submittedSiteDocuments: state => {
      return state.siteDocuments.submitted;
    },
    receivedSiteDocuments: state => {
      return state.siteDocuments.received;
    }
  },
  actions: {
    [GET_SITE_DOCUMENTS](context,payload){
      return new Promise((resolve,reject)=>{
          let url = this.getters.getSiteDocumentsUrl;
          ApiService.get(url + '?siteid=' + payload.siteId)
            .then(({data}) => {
              this.commit('storeSiteDocuments', data.data);
              this.commit('formatSiteDocuments');
              resolve();
            })
            .catch(error => {
              reject(error)
            })
        }
      );
    },
    [DOWNLOAD_SITE_DOCUMENT](context,payload){
      return new Promise((resolve,reject)=>{
        let url = payload.url;
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve(data);
          })
          .catch(error => {
            reject(error)
          });
      });
    },
    [DOWNLOAD_SITE_DOCUMENTS](context,payload){
      return new Promise((resolve,reject)=>{
        let url = this.getters.getSiteDocumentsUrl + '/bulk?';
        for (let id of payload.selectedIds) {
          url += `ids[]=${id}&`
        }
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve();
          })
          .catch( response => {
            console.log(response);
          });
      });
    },
    [UPLOAD_SITE_DOCUMENT](context,payload){
      return new Promise((resolve,reject)=>{
          var formData = new FormData();
          formData.append('file', payload.file);
          formData.append('siteId', payload.siteId);
          formData.append('description', payload.description);
          let url = this.getters.getSiteDocumentsUrl;
          ApiService.post(url, formData)
            .then(({ data }) => {
                resolve( {
                  success: false,
                  error: data
                });
            }).catch(({ response }) => {
              var err = response.data;
              var errMsg = err.message;
              if (err.data) {
                for (let p in err.data) {
                  if (Object.prototype.hasOwnProperty.call(err.data, p)) {
                    errMsg += `,${err.data[p]}`;
                  } else {
                    errMsg += `,${p}`;
                  }
                }
              };
              reject({
                success: false,
                error: errMsg
              });
            })
        }
      );
    },
    [PREVIEW_SITE_DOCUMENT](context,payload){
      let url = payload.url;
      return new Promise((resolve,reject)=>{
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then( response => {
            resolve(filePreview(response));
          })
          .catch( response => {
            console.log(response);
          });
      });
    }
  }
};

export default SiteDocumentModule;
